export const OptionKeys = {
  Customers: "customers",
  Engineers: "engineers",
  Salemen: "salesmen",
  Users: "users",
};
